import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { environment } from "environments/environment";
import { Supplier } from "@common/models/supplier";
import {
  Column,
  DataTableInput,
  DataTableOutput,
  Order,
  PagedData,
  Search,
} from "@core/models/datables";
import { TranslateService } from "@ngx-translate/core";

@Injectable({ providedIn: "root" })
export class SupplierService {
  private lang: string = this._translateService.currentLang;
  private columns: Column[];


  constructor(private _http: HttpClient, private _translateService: TranslateService) {   
  }

  getColumns() {
    this._translateService.onLangChange.subscribe(value => {
      if (value) {
        this.lang = value.lang;
      }
    });
    this.columns = [
      {
        "data": "id",
        "name": "ID",
        "searchable": true,
        "orderable": true,
        "search": {
            "regex": false,
            "value": ""
        }
    },
    {
        "data": "name",
        "name": "Name",
        "searchable": true,
        "orderable": true,
        "search": {
            "regex": false,
            "value": ""
        }
    }, {
        "data": "code",
        "name": "Code",
        "searchable": true,
        "orderable": true,
        "search": {
            "regex": false,
            "value": ""
        }
    },
     {
        "data": this.lang == "es" ? "classification" :  "classificationEnglish",
        "name": "Classification",
        "searchable": true,
        "orderable": true,
        "search": {
            "regex": false,
            "value": ""
        }
    },
     {
        "data": this.lang == "es" ? "status.name" : "status.nameEnglish",
        "name": "Status",
        "searchable": true,
        "orderable": true,
        "search": {
            "regex": false,
            "value": ""
        }
    } 
   
    
]}
  /*
  getAll(){
    return this._http.get<Supplier[]>(`${environment.commonApiUrl}/api/supplier`);
}*/



  /**
   * Funcion para listar proveedores paginados
   * @param page número de paginas
   * @param quantity cantidad
   * @returns devuelve lista pagina de proveedores
   */
  getAll(page: number, quantity: number) {
    return this._http.get<PagedData<Supplier>>(
      `${environment.commonApiUrl}/api/supplier/page/${page}/${quantity}`
    );
  }

  /**
   * Funcion que buscar un proveedor por medio de su ID
   * @param id Identificador de proveedor
   * @returns devuelve objeto tipo proveedor
   */
  getById(id: number) {
    return this._http.get<Supplier>(
      `${environment.commonApiUrl}/api/supplier/${id}`
    );
  }

  /**
   * Función para crear un proveedor
   * @param supplier objeto de tipo Proveedor
   * @returns 
   */
  addSupplier(supplier) {
    return this._http
      .post<Supplier>(`${environment.commonApiUrl}/api/supplier`, supplier)
      .pipe(
        map((response: any) => response.supplier as Supplier),
        catchError((e) => {
          return throwError(e);
        })
      );
  }

  /**
   * Función para actualizar un proveedor
   * @param supplier obtejo de tipo proveedor
   * @returns 
   */
  editSupplier(supplier) {
    return this._http
      .put<Supplier>(
        `${environment.commonApiUrl}/api/supplier/${supplier.id}`,
        supplier
      )
      .pipe(
        map((response: any) => response.supplier as Supplier),
        catchError((e) => {
          return throwError(e);
        })
      );
  }

  changeSupplierStatus(supplierId, statusCode) {
    return this._http
      .put(
        `${environment.commonApiUrl}/api/supplier/${supplierId}/${statusCode}`,
        {}
      )
      .pipe(
        map((response: any) => response.supplier as Supplier),
        catchError((e) => {
          return throwError(e);
        })
      );
  }


  /**
   * Seach supplier by classification and name
   * @param classification classification of supplier to looking for
   * @param name name of the supplier to looking for
   * @returns Array of supplier
   */
  getByName(classification: string, name: string){
    return this._http.get<Supplier[]>(`${environment.commonApiUrl}/api/supplier/classification/${classification}/name/${name}`);
  }

  getAllSupplier(
    page: number,
    quantity: number,
    order: Order,
    searchText: string
  ) {
    const input = this.createDataTableInput(page, quantity, order, searchText);
    return this._http.post<DataTableOutput<Supplier>>(
      `${environment.commonApiUrl}/api/supplier/index`,
      input
    );
  }

  private createDataTableInput(
    page: number,
    quantity: number,
    order: Order,
    searchText: string
  ): DataTableInput {
    this.getColumns();
    let input = new DataTableInput();
    input.start = page * quantity;
    input.length = quantity;
    if (searchText !== "") {
      input.search.regex = true;
      input.search.value = searchText;
    }
    if (order) {
      input.order.push(order);
    }
    input.columns = this.columns;
    return input;
  }

  /**
   * Seach supplier by classification and name
   * @param classification classification of supplier to looking for
   * @param name name of the supplier to looking for
   * @returns Array of supplier
   */
  getByNameWhitoutStatus(classification: string, name: string){
    return this._http.get<Supplier[]>(`${environment.commonApiUrl}/api/supplier/v2/classification/${classification}/name/${name}`);
  }
}
